<template>
  <Loader :loader="loaderActive"/>
  <div class="container-fluid">
    <div class="row" style="">
      <div class="store-head">
        <div class="back-link" @click="$router.back()">
          <i class="fas fa-chevron-left"></i>
        </div>
        <div class="category-title">
          <div style="margin-top: 16px; font-size: 20px;"> {{ $t('STORE') }}</div>
        </div>
      </div>
    </div>

    <div class="row mt-4">
      <p class="Tournament-bundle">Tournament Bundles</p>
    </div>
    <div class="row">


      <div v-for="slide in tournamentPacks" :key="slide.bundle_id" class=" pack-card col-sm-3">



          <div class="pack-title">
            {{ slide.title }}
          </div>
          <div class="pack-subtitle">
            {{ slide.caption }}
          </div>
          <div class="pack-amount-details d-flex justify-content-between ">
            <div class="amount">{{ slide.price }} {{ $t('BDT') }}</div>
            <div class="pack-subscribe" v-if="! slide.is_subscribed"
                 @click="getPayment(slide.bundle_id, 'bundle', false)">{{ $t('SUBSCRIBE_NOW') }}
            </div>
            <div class="pack-subscribe-disable" v-else>{{ $t('SUBSCRIBED') }}</div>
          </div>


      </div>


    </div>

    <DashboardFooterMenu/>
    <CoinModal :modal-show="showCoinModal" v-if="showCoinModal"/>
  </div>

</template>

<script>
import {sendRequest} from '@/http/axios.method';
import Loader from "@/views/components/Loader";
import {convertEnglishToMayanmar} from "@/helper/numberHelper";
import CoinModal from "@/views/components/CoinModal";
import DashboardFooterMenu from "@/views/components/DashboardFooterMenu";

export default {
  name: "store",
  components: {
    CoinModal,
    DashboardFooterMenu,
    Loader,
  },

  data() {
    return {
      loaderActive: false,
      config: {
        'AUTHORIZATION': 'Bearer ' + this.$store.state.authUser.token
      },
      wallet: [],
      popularProducts: [],
      topDeals: [],
      showCoinModal: false,
      tournamentPacks: [],
    };
  },
  created() {
    this.getTournamentPacks();
    this.emitter.on('coin-modal-close-event', (evt) => {
      this.showCoinModal = evt.eventContent;
    });
  },
  methods: {
    convertNumberToLangWise(data) {
      let numberDataWithLang = {
        'number': data,
        'lang': this.$store.getters.language
      };
      return convertEnglishToMayanmar(numberDataWithLang);
    },

    getTournamentPacks() {
      this.loaderActive = true;
      sendRequest('get', 'v2.0/tournament-packs', {}, this.config)
          .then(response => {
            this.loaderActive = false;
            if (response.success) {
              this.tournamentPacks = response.data.packages;
            }
          })
          .catch(() => {
            this.loaderActive = false;
          });
    },
    getPayment(payment_id, payment_type, is_on_demand) {
      this.$router.push({
        path: '/payment-method',
        query: {payment_id: payment_id, type: payment_type, is_on_demand: is_on_demand}
      });
    }
  },

};
</script>

<style scoped>
.carousel__item {
  width: 300px;
  border-radius: 8px;
}
</style>
